export default __webpack_public_path__ + "static/media/pokemon_shiny_ultra_rare.79db1be3.svg";